<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="dedicationText"><em class="italic">To anyone<br/>
<br/>
who works with or talks to the press.<br/>
<br/>
It may not be easy,<br/>
<br/>
but at all times a free press helps keep<br/>
<br/>
our nation free.</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061755149_dedication.vue?105c9061